// extracted by mini-css-extract-plugin
export default {"search_box":"index_search_box_-Fkmr","search_text":"index_search_text_nkp7c","sousuo_btn":"index_sousuo_btn_AN0pT"};